import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  workspaceDetails: {
    modelId: null,
    skuId: null,
    skuDescription: null,
    poCost: null,
    currencySymbol: '$',
    vendorName: null,
    baseShouldCost: null,
    sscmId: null,
    skuModelVendorId: null,
    svmId: null,
    skuData: [],
  },
  simulationModelDetails: {
    simulationId: null,
    name: null,
    manufacturingCountry: null,
    currency: 'Dollar ($)',
    creationDate: null,
    description: null,
  },
  baseModelDetails: {
    id: null,
    name: null,
    description: null,
    category: null,
    country_of_origin: null,
    should_cost: null,
    created_date: null,
    missing_index_ticker_count: 0,
  },
}

const getWhatIfDetailsSlice = createSlice({
  name: 'sku-list-filters',
  initialState,
  reducers: {
    // Setter for workspaceDetails
    setWorkspaceDetails(state, action) {
      state.workspaceDetails = { ...state.workspaceDetails, ...action.payload }
    },

    // Setter for simulationModelDetails
    setSimulationModelDetails(state, action) {
      state.simulationModelDetails = { ...state.simulationModelDetails, ...action.payload }
    },

    // Setter for baseModelDetails
    setBaseModelDetails(state, action) {
      state.baseModelDetails = { ...state.baseModelDetails, ...action.payload }
    },

    // Resetter for only workspaceDetails
    resetWorkspaceDetails(state) {
      state.workspaceDetails = { ...initialState.workspaceDetails }
    },

    // Resetter for only simulationModelDetails
    resetSimulationModelDetails(state) {
      state.simulationModelDetails = { ...initialState.simulationModelDetails }
    },

    // Resetter for only baseModelDetails
    resetBaseModelDetails(state) {
      state.baseModelDetails = { ...initialState.baseModelDetails }
    },
  },
})

export const {
  setWorkspaceDetails,
  setSimulationModelDetails,
  setBaseModelDetails,
  resetWorkspaceDetails,
  resetSimulationModelDetails,
  resetBaseModelDetails,
  resetWhatIfDetails,
} = getWhatIfDetailsSlice.actions

export default getWhatIfDetailsSlice.reducer
